import { Slide } from "@jelly/lesson";
import { task as task02 } from "../../../../../task/course-05/lesson-11/task-02";

const task: Slide = {
  title: `To be able to perform well in a hall, musicians need to:`,
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
